import { SignalCellularNullRounded } from '@material-ui/icons';
import { createSlice } from '@reduxjs/toolkit';

// Slice
const initialCountiesList = localStorage.getItem('countiesList') && localStorage.getItem('countiesList') !== 'undefined'
  ? JSON.parse(localStorage.getItem('countiesList'))
  : []

  const initialCounty= localStorage.getItem('currentCounty')
  ? JSON.parse(localStorage.getItem('currentCounty'))
  : SignalCellularNullRounded

const slice = createSlice({
  name: 'countiesList',
  initialState: {
    countiesList: initialCountiesList,
    currentCounty: initialCounty
  },
  reducers: {
    countiesListSuccess: (state, action) => {
      state.countiesList = action.payload;
      localStorage.setItem('countiesList', JSON.stringify(action.payload));
    },
    setSelectedCountySuccess: (state, action) => {
      state.currentCounty = action.payload;
      localStorage.setItem('currentCounty', JSON.stringify(action.payload));
    },
    clearCountyListSuccess: (state, action) =>  {
      state.countiesList = [];
      localStorage.removeItem('countiesList');
    },
  },
});

export default slice.reducer;

// Actions
const { countiesListSuccess, setSelectedCountySuccess, clearCountyListSuccess } = slice.actions;

export const setCountiesList = (currentList) => async dispatch => {
  try {
    dispatch(countiesListSuccess(currentList));
  } catch (e) {
    return console.error(e.message);
  }
}

export const setSelectedCounty = (county) => async dispatch => {
  try {
    dispatch(setSelectedCountySuccess(county));
  } catch (e) {
    return console.error(e.message);
  }
}


export const clearCountyList = () => async dispatch => {
  try {
    // const res = await api.post('/api/auth/clearCountyList/')
    return dispatch(clearCountyListSuccess())
  } catch (e) {
    return console.error(e.message);
  }
}
